//React
import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as favoriteAction from '../action/favoriteAction';
import * as helpAction from '../action/helpAction';

//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
//Add
import Masonry from 'react-masonry-component';
//Func
import atom2datetime from '../func/atom2datetime';
//Menu
import MenuSearch from './MenuSearch';
import MenuFavorite from './MenuFavorite';
//Part
import PartUserName from './PartUserName';
import PartUserMainImg from './PartUserMainImg';
import PartUserSubImg from './PartUserSubImg';
import PartPagingNextPrev from './PartPagingNextPrev';
import DialogCoupleRequest from './DialogCoupleRequest';
import PartTimeIcon from './PartTimeIcon';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import MailIcon from '@material-ui/icons/Mail';
import PeopleIcon from '@material-ui/icons/People';
import RefreshIcon from '@material-ui/icons/Refresh';
import ClearIcon from '@material-ui/icons/Clear';

class Comp extends React.Component {

  constructor(props) {
    super(props);

  	this.state = {
      favoriteDelPic: null,
      coupleSendPic: null,
  	}
  }

  componentDidMount() {
    document.title = 'お気に入り(自分から) - パートナーズ';

    if (this.props.history.action === 'PUSH' || !this.props.favorite.my.datetime) {
      this.props.favoriteMyListGet(1);
      window.scrollTo(0, 0);
    }
  }


  _favoriteDelSubmit() {
    this.props.favoriteMyDel(this.state.favoriteDelPic, () => {
      this.setState({favoriteDelPic: null});
    });
  }

  _paging(page) {
    this.props.favoriteMyListGet(page);
    window.scrollTo(0, 0);
  }

  _renderList = (value, index) => {

    if (value.userdata_attestation !== 1 || value.userdata_service_stop !== 0) {
      return (
        <div key={index} className='box_outer'>
          <Box className='box_innner round12' boxShadow={2}>

            <div style={{padding:'2%'}}>
              <div style={{textAlign:'center'}}>
                <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                  <PartUserName
                    data={{
                      name: value.userdata_name,
                      sex: value.userdata_sex,
                      size: '1.4em',
                    }}
                  />
                </Link>
                <div>
                  {value.userdata_age}才 {value.userdata_prof_region} {value.userdata_prof_region_detail}
                </div>
              </div>
              <div className='box_left'>
                <div style={{margin:'1%'}}>
                  <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                    <div align='center'>
                      <PartUserMainImg
                        mainImg={value.userdata_mainImg}
                        maxWidth={'180px'}
                        width={'100%'}
                        height={'auto'}
                        radius={'50%'}
                        lazyLoad={false}
                      />
                    </div>
                  </Link>
                </div>
              </div>

              <div className='box_right'>

              </div>
            </div>

            <div style={{clear:'both'}}></div>

            {
              (value.favorite_notice === 1) && (
                <div align='center'>
                  <span className='black_trans_icon'>お気に入り通知</span>
                </div>
              )
            }
            <div style={{textAlign:'center', margin:'10px'}}>
              <PartTimeIcon
                text={atom2datetime(value.favorite_datetime_atom, 'D') + ' お気に入り登録'}
              />
            </div>


            <div
              className='favorite_box_menu'
              style={{
                marginTop: '10px',
                borderTop: '1px solid #CCC'
              }}
            >
              <div
                className='item'
                onClick={ () => this.setState({favoriteDelPic: value.userdata_id_code}) }
              >
                <ClearIcon className='icon'/>
                <div className='text'>削除</div>
              </div>
            </div>
          </Box>
        </div>
      )
    }
    else {
      return (
        <div key={index} className='box_outer'>
          <Box className='box_innner round12' boxShadow={2}>
            {
              (value.favorite_both === 1) && (
                <div
                  className='ribbon_orange'
                  style={{position:'absolute', top:'0px', left:'0px',cursor:'pointer'}}
                  onClick={ () => this.props.helpOpen('id',45) }
                >
                  両思い
                </div>
              )
            }

            <div style={{padding:'2%'}}>
              <div style={{textAlign:'center'}}>
                <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                  <PartUserName
                    data={{
                      name: value.userdata_name,
                      sex: value.userdata_sex,
                      size: '1.4em',
                    }}
                  />
                </Link>
                <div>
                  {value.userdata_age}才 {value.userdata_prof_region} {value.userdata_prof_region_detail}
                </div>
              </div>
              <div className='box_left'>
                <div style={{margin:'1%'}}>
                  <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                    <div align='center' style={{paddingBottom:'20px'}}>
                      <div style={{ display: 'inline-block', padding:'4px', position: 'relative' }}>
                        <PartUserMainImg
                          mainImg={value.userdata_mainImg}
                          maxWidth={'160px'}
                          width={'100%'}
                          height={'auto'}
                          radius={'50%'}
                        />
                        <div style={{
                          position: 'absolute',
                          bottom:'-20px',
                          left:'0px',
                          right:'0px',
                          margin: 'auto',
                        }}>
                          <PartUserSubImg
                            photoSub={value.photo_sub}
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

              <div className='box_right'>
                {
                  (value.userdata_prof_partner_comment.length > 0) &&
                  <div
                    className='comment round12'
                    style={{fontSize:'0.9em', color:'#666', margin:'1%'}}
                  >
                    {value.userdata_prof_partner_comment}
                  </div>
                }

                { (value.userdata_proof_person === 1) && (<span className='proof_icon'>本人証明</span>) }
                { (value.userdata_proof_photo === 1) && (<span className='proof_icon'>写真証明</span>) }
                { (value.userdata_proof_income === 1) && (<span className='proof_icon'>収入証明</span>) }
                { (value.userdata_proof_single === 1) && (<span className='proof_icon'>独身証明</span>) }
                { (value.userdata_proof_credit === 1) && (<span className='proof_icon'>ｸﾚｼﾞｯﾄ証明</span>) }
                { (value.post_count > 0) && (<span className='post_icon'>投稿 {value.post_count}件</span>) }
                { (value.qa_count > 0 || value.qa_answer_count > 0) && (
                  <span className='qa_icon'>Q&A
                    { (value.qa_count > 0) && (value.qa_count + '問')}
                    { (value.qa_answer_count > 0) && (value.qa_answer_count + '答')}
                  </span>
                ) }
                { (value.character_type16) && (<span className='personality_icon'>性格</span>) }
              </div>
            </div>

            <div style={{clear:'both'}}></div>

            {
              (value.favorite_notice === 1) && (
                <div align='center'>
                  <span className='black_trans_icon'>お気に入り通知</span>
                </div>
              )
            }
            <div style={{textAlign:'center', margin:'10px'}}>
              <PartTimeIcon
                text={atom2datetime(value.favorite_datetime_atom, 'D') + ' お気に入り登録'}
              />
            </div>


            <div
              className='favorite_box_menu'
              style={{
                marginTop: '10px',
                borderTop: '1px solid #CCC'
              }}
            >
              <div
                className='item'
                style={{borderRight: '1px solid #CCC'}}
                onClick={ () => this.props.history.push({pathname:"/mailbox/talk/"+value.userdata_id_code, referrer:'/favorite/my/'}) }
              >
                <MailIcon className='icon'/>
                <div className='text'>メール</div>
              </div>
              <div
                className='item'
                onClick={ () => this.setState({coupleSendPic: value.userdata_id_code}) }
                style={{borderRight: '1px solid #CCC'}}
              >
                <PeopleIcon className='icon'/>
                <div className='text'>カップリング</div>
              </div>
              <div
                className='item'
                onClick={ () => this.setState({favoriteDelPic: value.userdata_id_code}) }
              >
                <ClearIcon className='icon'/>
                <div className='text'>削除</div>
              </div>
            </div>
          </Box>
        </div>
      )
    }
  };


  render() {
    return (
      <div>
        <MenuSearch />

        <MenuFavorite />

        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent: 'space-between',
            margin: '10px',
          }}
        >
          <div>
            { this.props.favorite.my.count } / {this.props.config.favoriteLimit}件
          </div>
          <div>
            <span style={{color:'#666'}}>ページ{this.props.favorite.my.page}</span>

            <IconButton
              onClick={ () => this.props.favoriteMyListGet(1) }
            >
              <RefreshIcon />
            </IconButton>
          </div>
        </div>

        <div id="user_list_block">
          {
            (this.props.favorite.my.datetime) && (
              (this.props.favorite.my.list.length > 0) ? (
                <div>
                  <Masonry options={{
                    itemSelector: '.box_outer',
                    transitionDuration: 0,
                  }}>
                    {
                      this.props.favorite.my.list.map(
                        (value, index) => this._renderList(value, index)
                      )
                    }
                  </Masonry>
                  <div style={{margin:'15px'}}>
                    <PartPagingNextPrev
                      page={this.props.favorite.my.page}
                      isNext={this.props.favorite.my.isListNext}
                      onClick={ (e) => this._paging(e) }
                    />
                  </div>
                </div>
              ) : (
                <h2 align='center' style={{padding:'30px 0px'}}>
                <div>自分からのお気に入りは</div>
                <div>見つかりませんでした</div>
                </h2>
              )
            )
          }
        </div>

        <div align='center' style={{margin:'15px'}}>
          <span className='i-b' style={{margin:'3px'}}>
            <Button
              color="primary"
              variant={ "outlined" }
              onClick={ () => this.props.helpOpen('category','favorite') }
            >
              「お気に入り」とは？
            </Button>
          </span>
          <span className='i-b' style={{margin:'3px'}}>
            <Button
              color="primary"
              variant={ "outlined" }
              onClick={ () => this.props.helpOpen('category','couple') }
            >
              「カップリング」とは？
            </Button>
          </span>
        </div>

        <DialogConfirm
          open={ (this.state.favoriteDelPic) ? true : false }
          title={'お気に入りを削除'}
          content={'お気に入りから1件削除してもいいですか？'}
          apply={ () => this._favoriteDelSubmit() }
          close={ () => this.setState({favoriteDelPic: null}) }
        />

        <DialogCoupleRequest
          open={ (this.state.coupleSendPic) ? true : false }
          pic={ this.state.coupleSendPic }
          close={ () => this.setState({coupleSendPic: null}) }
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    config: state.config,
		favorite: state.favorite,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...favoriteAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
